import React, { useCallback, useState } from 'react';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import styled from 'styled-components';
import { faPlus, faFolder } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RequestState } from 'shared/auth/hooks/useRequestState';
import { Program } from '../../Reports/NewReportDialog';
import { NPOUser } from '../../ReportsBeta/NewProgram/api';
import NewProgram from '../../ReportsBeta/NewProgram';

interface InvestmentSplitButtonsProps {
  allPrograms: RequestState<{
    allPrograms: Program[];
  }>;
  allNPOUsers: RequestState<{
    allUsers: NPOUser[];
  }>;
  selectedProgram: Program | undefined;
  reloadTasks: () => unknown;
  reloadPrograms: (programId: number) => unknown;
  reloadNPOUser: () => unknown;
  handleAdd: () => unknown;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACERS.small};
  margin-top: ${SPACERS.medium};
  .allocation-add-button-icon {
    margin-left: ${SPACERS.tiny};
    margin-right: ${SPACERS.tiny};
  }
  .allocation-add-button {
  }
`;

const noOp = () => null;
const InvestmentSplitButtons: React.FC<InvestmentSplitButtonsProps> = ({
  allNPOUsers,
  allPrograms,
  reloadNPOUser,
  reloadPrograms,
  reloadTasks,
  handleAdd,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleProgramClose = (programId?: number) => {
    programId && reloadPrograms(programId);
    handleClose();
  };

  return (
    <StyledDiv>
      <TrueImpactButton
        onClick={handleOpen}
        variant="secondary-large"
        backgroundColor="ctaPrimaryBackground"
      >
        <FontAwesomeIcon
          icon={faFolder}
          className="allocation-add-button-icon"
        />{' '}
        New Program
      </TrueImpactButton>
      <TrueImpactButton
        onClick={handleAdd}
        variant="secondary-large"
        backgroundColor="ctaPrimaryBackground"
      >
        <FontAwesomeIcon icon={faPlus} className="allocation-add-button-icon" />{' '}
        Add Allocation
      </TrueImpactButton>
      <NewProgram
        open={open}
        allNPOUsers={allNPOUsers}
        programsList={allPrograms}
        reloadProgramList={noOp}
        onClose={handleProgramClose}
      />
    </StyledDiv>
  );
};

export default InvestmentSplitButtons;
